// extracted by mini-css-extract-plugin
module.exports = {"section":"Skills_section__v4efF","badge":"Skills_badge__G4tOA","skills":"Skills_skills__WBYiu","item":"Skills_item__OzMW9"};